import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function TruthSection() {
  return <section className="py-16 md:py-24 px-4 bg-slate-950 border-y border-slate-800/50" data-id="element-277">
      <div className="max-w-3xl mx-auto" data-id="element-278">
        <FadeIn data-id="element-279">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white text-center mb-12" data-id="element-280">
            LA VERDAD QUE NADIE TE DICE
          </h2>
        </FadeIn>

        <div className="space-y-8" data-id="element-281">
          <FadeIn delay={0.1} data-id="element-282">
            <p className="text-xl md:text-2xl text-slate-400 leading-tight" data-id="element-283">
              El problema no es tu condición física.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-284">
            <p className="text-xl md:text-2xl text-white font-bold leading-tight" data-id="element-285">
              El problema es que entrenás sin un método de progresión.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-286">
            <div className="my-16" data-id="element-287">
              <p className="text-2xl md:text-3xl text-amber-500 italic text-center font-serif font-bold leading-relaxed" data-id="element-288">
                El 80% del estancamiento del ciclista amateur viene de errores
                sistémicos y prevenibles.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-289">
            <div className="bg-slate-900 border border-slate-800 border-l-2 border-l-amber-500 rounded-2xl p-8 md:p-10 space-y-6 text-lg md:text-xl text-slate-300 font-light" data-id="element-290">
              <p data-id="element-291">No son errores de talento.</p>
              <p data-id="element-292">
                Son errores que ocurren porque no existe una estructura de
                entrenamiento progresiva y medible detrás de cada salida.
              </p>
              <p data-id="element-293">
                Tu cuerpo no te avisa que se estancó. Te deja pedalear. Y
                después llega la frustración.
              </p>
            </div>
          </FadeIn>

          <div className="pt-12 space-y-8" data-id="element-294">
            <FadeIn delay={0.5} data-id="element-295">
              <p className="text-xl text-slate-400" data-id="element-296">
                La solución no es pedalear más horas.
              </p>
            </FadeIn>
            <FadeIn delay={0.6} data-id="element-297">
              <p className="text-2xl md:text-3xl text-amber-500 font-bold italic text-center font-serif" data-id="element-298">
                La solución es tener un sistema de progresión preventiva.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}